const dig = (obj, path) => {
  let a = path.split('.')
  let o = obj

  while (a.length) {
    let n = a.shift()

    if (!(n in Object(o)))
      return

    o = o[n]
  }

  return o
}

export default dig
